import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
  name: 'getDocuments'
})
export class GetDocumentsPipe implements PipeTransform {

  transform(value: unknown, documentType: string): string {
    // signatureImage
    return environment.apiUrl + `api/General/GeDocuments/${documentType}/${value}`;
  }

}
